import React from 'react';
import Users from './Users';

export function UsersPage(): React.ReactElement {
  return <Users />;
}
